/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Loading from "../../home/components/Loading";
import { AppAPIService } from "../../../services/AppAPIService";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import { Container, StyledModal } from "./style";
import { useLocation } from "react-router-dom";

const ActivateAccount = () => {
  const api = AppAPIService.getInstance();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const token = params.get("token");
  console.log(email, token);

  const handleActivateAccount = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.makeHttpRequest({
        url: "/auth/activate-account",
        method: "GET",
        params: {
          email: email,
          token: token,
        },
      });
      Swal.fire({
        title: "Sucesso!",
        text: "Conta ativada com sucesso! Faça o login para continuar!",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        setIsLoading(false);
      });
      console.log("response", response);
    } catch (error) {
      console.log("error", error);
      console.log("error.response", error.response);
      Swal.fire({
        title: "Erro!",
        text: "Não foi possível ativar a conta!",
        icon: "error",
        confirmButtonText: "Ok",
      }).then(() => {
        setIsLoading(false);
      });
    }
  }, [api, email, token]);

  React.useEffect(() => {
    handleActivateAccount();
  }, [handleActivateAccount]);

  return (
    <>
      <Container>
        <h1>Ativação de conta advocacia xavier</h1>
        <Button
          onClick={() => {
            window.location.href = "/auth/login";
          }}
          style={{ marginTop: "20px", color: "white" }}
        >
          Clique aqui para ir para a página de login
        </Button>
      </Container>
    </>
  );
};

export default ActivateAccount;
